import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'components/layout'
import { PersonalBlock, AddressBlock } from 'components/sections/common'
import { Button } from 'components/misc'
import { apiContacts, apiCodeLists, apiConfiguration } from 'helpers/decorators/api'
import { form } from 'helpers/decorators'
import { createValidate } from 'models/contacts'
import { connect } from 'react-redux'
import { checkEmail } from '../../../../redux/modules/api/asyncValidations'
import { asyncValidate } from 'models/persons/asyncValidate'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'

@apiContacts({
  list: true
})
@apiConfiguration()
@apiCodeLists(['titles', 'phoneTypes'])
@connect(() => ({ auth }) => ({
    activeOrganizationId: auth.organization.id
  }),
  { checkEmail })
@form({
  form: 'create-contact-form',
  disableHook: true,
  validate: createValidate,
  asyncValidate
})
class ContactCreate extends Component {
  static propTypes = {
    codeLists: PropTypes.object.isRequired,
    submitting: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onCreateContact: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    isOrganizationContact: PropTypes.bool.isRequired,
    activeOrganizationId: PropTypes.number.isRequired,
    isOrgConfigurationTrue: PropTypes.func.isRequired
  }

  static defaultProps = {
    isOrganizationContact: true
  }

  render() {
    const {
      handleSubmit,
      onCreateContact,
      codeLists,
      change,
      onClose,
      submitting,
      isOrganizationContact,
      activeOrganizationId
    } = this.props

    const showSecondaryEmail = this.props.isOrgConfigurationTrue(activeOrganizationId, CONFIGURATION_KEYS.awardStaffRegistrationEmailAddress2.id)

    const showPhone = this.props.isOrgConfigurationTrue(activeOrganizationId, CONFIGURATION_KEYS.awardStaffRegistrationPhone.id)

    const showMiddleName = this.props.isOrgConfigurationTrue(activeOrganizationId, CONFIGURATION_KEYS.awardStaffRegistrationMiddleName.id)

    const showAddressLine1 = this.props.isOrgConfigurationTrue(activeOrganizationId, CONFIGURATION_KEYS.awardStaffRegistrationAddressLine1.id)

    const showAddressLine2 = this.props.isOrgConfigurationTrue(activeOrganizationId, CONFIGURATION_KEYS.awardStaffRegistrationAddressLine2.id)

    const showCity = this.props.isOrgConfigurationTrue(activeOrganizationId, CONFIGURATION_KEYS.awardStaffRegistrationAddressCity.id)

    const showZipCode = this.props.isOrgConfigurationTrue(activeOrganizationId, CONFIGURATION_KEYS.awardStaffRegistrationAddressZipCode.id)

    const showRegion = this.props.isOrgConfigurationTrue(activeOrganizationId, CONFIGURATION_KEYS.awardStaffRegistrationAddressRegion.id)

    const showCountry = this.props.isOrgConfigurationTrue(activeOrganizationId, CONFIGURATION_KEYS.awardStaffRegistrationAddressCountry.id)

    const showAddressBlock = showAddressLine1 || showAddressLine2 || showCity || showZipCode || showRegion || showCountry


    return (
      <Form onSubmit={handleSubmit(onCreateContact)}>
        <div className="row">
          <div className="col-xs-6">
            <PersonalBlock
              title="Contact info"
              intlKey="moduleTitle.contact_info"
              titles={codeLists.titles.list}
              phoneTypes={codeLists.phoneTypes.list}
              change={change}
              omitNote
              omitPhoto
              hasMiddleName={false}
              isOrganizationContact={isOrganizationContact}
              showSecondaryEmail={showSecondaryEmail}
              showTertiaryEmail={showSecondaryEmail}
              showMiddleName={showMiddleName}
              showPhone={showPhone}
              showPhoneType
            />
          </div>

          {showAddressBlock && <div className="col-xs-6">
            <AddressBlock
              change={change}
              formPrefix="address"
              withCountry
              showAddressLine1={showAddressLine1}
              showAddressLine2={showAddressLine2}
              showCity={showCity}
              showZipCode={showZipCode}
              showRegion={showRegion}
              showCountry={showCountry}
            />
          </div>}
        </div>

        <div className="row">
          <div className="col-xs-6">
            <Button
              type="button"
              intlKey="button.close"
              onClick={onClose}
              secondary
            >
              Close
            </Button>
          </div>

          <div className="col-xs-6 text--right">
            <Button intlKey="button.create" isLoading={submitting}>
              Create
            </Button>
          </div>
        </div>
      </Form>
    )
  }
}

export default ContactCreate
